import { gql } from 'graphql.macro';

export const GetReportsTemplate = gql`
    query Reports {
        reports {
            _id
            name
            type
            filters {
                date
                clinic
                category
                status
            }
        }
    }
`;

export const GetReportDescriptionTemplate = gql`
    query getReportDescription($reportName: String!, $language: String) {
        getReportDescription(reportName: $reportName, language: $language)
    }
`;

export const CreateReportTemplate = gql`
    query CreateReports($id: MongoDbObjectId!, $options: OptionsInput) {
        createReports(_id: $id, options: $options) {
            columns {
                name
                value
                type
            }
            data {
                id
                labName
                name
                numberOfOrders
                reasons {
                    type
                    count
                    name
                }
                ADHERENCE
                PATIENT_NEEDS
                labs {
                    name
                    count
                }
                adherencePercentage
                satisfied
                notSatisfied
                satisfiedPercent
                notSatisfiedPercent
                numberOfTotalOrders
                numberOfRatedOrders
                orderId
                rating
                remarks {
                    type
                    count
                    name
                }
                comment
                ratedBy {
                    ... on UserName {
                        firstName
                        lastName
                    }
                    ... on StringValue {
                        stringValue: value
                    }
                }
                clinic
                destination
                customerSettings {
                    _id
                    name
                    settingValue: value
                    type
                }
                patientCategories {
                    minage
                    maxage
                    name
                    translatedName
                    categoryTotalAmount
                    categoryValue: value
                }
                clinicCc
                createdYearMonth
                totalAmount
                syncID {
                    ... on IntValue {
                        intValue: value
                    }
                    ... on StringValue {
                        stringValue: value
                    }
                }
                satisfactionPercent
                parentClinic
                total
                email
                created
                clinicName
                numberOfDigitalSample
                numberOfPhysicalSample
                numberOfNoSample
                invoiceNumber {
                    ... on IntValue {
                        intValue: value
                    }
                    ... on StringValue {
                        stringValue: value
                    }
                }
                invoiceStatus
                invoiceDate
                amountExclVat
                VAT
            }
        }
    }
`;
